module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0073.jpg?v=acd21cb8";